$(document).ready(function() {
  $(".toggleingredients").click(function(event) {
    event.preventDefault();
    var target = $(this).data("target");
    $("#" + target).toggle("fast"); // Adjust the speed by changing "slow" to a specific duration, e.g., "2000" for 2 seconds
    $(this).text(function(_, text) {
      return text === "+ View all ingredients" ? "- View all ingredients" : "+ View all ingredients";
    });
  });
$(".mega-menu__list").hover(function () {
  console.log($(this).text().trim());
  if($(this).text().trim() == "Shop All Products"){
      $(".test77 .sub_menu").removeClass("active");
  }
});
  $(".products-menu").hover(function () {
      let spanText = $(this).children("a").find("span").text().trim();

  $(".sub_menu li a").removeClass("mega-menu__link--active");

      console.log(spanText);
     $(".test77 .sub_menu").removeClass("active");
      if(spanText == "Shop"){
          $("a[title='Devices']").addClass("mega-menu__link--active");
          $("[data-menu-title='Devices']").addClass("active");
      }
  });

//   $(document).on("click", ".nav-item.dropdown.second-level", function () {
//     // Remove "open" class from all other divs
//     $(".nav-item.dropdown.second-level").not(this).removeClass("open");
    
//     // Toggle "open" class on the clicked div
//     $(this).toggleClass("open");
// });

  $(".submenu-accordion").on("click", function () {
  console.log("here");
  $(".submenu-accordion").not(this).removeAttr("open");
    console.log("This message appears after 3 seconds");
    $(this).parent().find(".nav-item-shop-topical-skincare .submenu-accordion").each(()=>{
      
    })
    
});
  
});